export default "__VITE_ASSET__BgUIURAh__"